export enum EDataModelSchemaType {
  'STRING' = 'STRING',
  'BOOLEAN' = 'BOOLEAN',
  'INTEGER' = 'INTEGER',
  'RECORD' = 'RECORD',
  'DATE' = 'DATE',
}
